import type { Component, PropType } from 'vue';
import { defineComponent, h, shallowRef, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useUiSettings } from '../../ui-settings';
import SiderLayout from './SiderLayout.vue';
import TopBarLayout from './TopBarLayout.vue';

export const LayoutManager = defineComponent({
  props: {
    default: {
      type: Object as PropType<Component>,
      default: SiderLayout,
    },
  },
  setup(props, { slots }) {
    const currentLayout = shallowRef<Component>(props.default || SiderLayout);
    const router = useRouter();
    const { features } = useUiSettings();

    watch(
      () => router.currentRoute.value,
      (route) => {
        let layout = (route.meta.layout as Component) || props.default || SiderLayout;
        if (features.value.altSidebarMenu && layout === SiderLayout) {
          layout = TopBarLayout;
        }
        if (currentLayout.value !== layout)
          currentLayout.value = layout;
      },
      {
        immediate: true,
        deep: true,
      },
    );

    return () => h(currentLayout.value, null, slots);
  },
});
